import { track } from '../lib/track'
import ApplicationController from './application_controller'

// Declarative Plausible custom-event emitter.
//
//   <div data-controller="track"
//        data-track-event-value="signup_completed"
//        data-track-props-value='{"plan":"starter"}'></div>
//
// Fires once on connect. Typically rendered server-side from
// flash[:plausible_event] (see PlausibleEventQueue#plausible_event!).
export default class extends ApplicationController {
  static values = {
    event: String,
    props: { type: Object, default: {} },
  }

  connect() {
    if (!this.eventValue) return
    try {
      track(this.eventValue, { props: this.propsValue })
    } catch (error) {
      // Stimulus swallows connect-time errors silently. Track throws
      // when init() failed earlier (second-init guard, missing domain) —
      // route to AppSignal so analytics outages have a real signal.
      this.reportError(error, { event: this.eventValue, source: 'plausible_tracker' })
    }
  }
}
